import SensorDto from './SensorDto'

export default class SensorAssignatedDto extends SensorDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
